import { Component, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CloseOverlayService } from '../../_services/closeOverlay.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.page.html',
  styleUrls: ['./privacy.page.scss'],
})
export class PrivacyPage implements OnInit {
  subscription: any;

  constructor(
    private modalController: ModalController, private router: Router,
    private platform: Platform, private location: Location, private closeOverlayService: CloseOverlayService
  ) { }

  dismiss() {
    this.modalController.dismiss();
  }

  demoTransaction() {
    this.router.navigateByUrl('demo/payment');
    this.modalController.dismiss();
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      if (this.constructor.name === 'PrivacyPage') {
        this.closeOverlayService.trigger();
      } else {
        this.location.back();
      }
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
  }

}
